import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Icon({ className, icon }) {
  return (
    <div className={classNames('approval-status-icon', className)}>
      <FontAwesomeIcon icon={icon} size="xs" />
    </div>
  );
}

Icon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.object.isRequired,
};
